<template>
    <div class="load-container">
        <i></i>
        <p>loading…</p>
    </div>
</template>

<script>
export default {
    name: 'newMaterialLoad',
    data() {
        return {
            
        }
    }
}
</script>

<style lang="less" scoped>
    .load-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 116px;

        i {
            display: block;
            width: 22px;
            height: 24px;
            background: url('../../../common/newMaterialBox/assets/load.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            margin-bottom: 14px;
            animation: 'rotate' 1.5s linear infinite;
        }

        p {
            font-size: 14px;
            line-height: 20px;
            color: #050F0F;
            font-weight: 500;
        }
    }

    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>